import React from "react";
import { Mail, Phone, MapPin, Clock, MessageSquare } from "lucide-react";
import { LeadConsultationForm } from "@/components/LeadConsultationForm";

export const ContactPage: React.FC = () => {
  return (
    <div className="pt-24 pb-20 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <span className="text-xs font-extrabold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-md">
            Direct Communication
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Contact Feingold Property Management
          </h1>
          <p className="text-slate-600 dark:text-slate-300 text-base">
            Have questions about managing your commercial or residential
            property? Our dedicated team is here to assist you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Info Side */}
          <div className="lg:col-span-5 space-y-8">
            <div className="bg-slate-900 text-white p-8 rounded-2xl border border-slate-800 shadow-xl space-y-6">
              <h2 className="text-xl font-bold text-white border-b border-slate-800 pb-4">
                Corporate Office
              </h2>

              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-primary/20 text-accent">
                  <MapPin className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-bold text-sm text-white">
                    Feingold Property Management, LLC
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    Commercial & Residential Operations Headquarters
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="p-3 rounded-xl bg-accent/20 text-accent">
                  <Clock className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-bold text-sm text-white">
                    Office Hours
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    Monday - Friday: 9:00 AM - 5:00 PM EST
                  </div>
                  <div className="text-xs text-emerald-400 font-semibold mt-0.5">
                    24/7 Emergency Dispatch for Residents
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="p-3 rounded-xl bg-sky-500/20 text-sky-400">
                  <MessageSquare className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-bold text-sm text-white">
                    Digital Portals
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    Online portals available 24 hours a day for owners and
                    residents.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Form Side */}
          <div className="lg:col-span-7">
            <LeadConsultationForm title="Send Us a Direct Message" />
          </div>
        </div>
      </div>
    </div>
  );
};
